<template>
  <div class="client-center-home">
    <!--企业基本信息-->
    <CardEdit
      ref="formBasic"
      formName="formBasic"
      :source-data="sourceDataBasic"
      :schema="BASIC_INFO_SCHEMA"
      layout="horizontal"
      :labelCol="labelCol"
      :wrapperCol="wrapperCol"
      :defaultColXs="24"
      :defaultColSm="24"
      :defaultColMd="24"
      :defaultColLg="12"
      :defaultColXl="8"
      @handleBusiTypeChange="value => handleBusiTypeChange(value, 'formBasic')"
    >
      <!-- 联动select，具名插槽 -->
      <template v-slot:region="slotProps">
        <a-select
          :disabled="slotProps.item.disabled"
          :placeholder="slotProps.item.placeholder || '请选择'"
          v-decorator="[
            slotProps.item.key,
            {
              initialValue: slotProps.item.value,
              rules: slotProps.item.rules,
            },
          ]"
        >
          <a-select-option
            v-for="optionItem in regionOptionList"
            :value="optionItem.id"
            :key="optionItem.id"
            :disabled="optionItem.disabled"
          >
            {{ optionItem.name }}
          </a-select-option>
        </a-select>
      </template>
      <!-- 业务模式 -->
      <template v-slot:model="slotProps">
        <a-select
          :placeholder="slotProps.item.placeholder || '请选择'"
          v-decorator="$decorator(slotProps.item.key, '请选择业务模式')"
          @focus="handleModelFocus"
        >
          <a-select-option
            v-for="optionItem in modelOptionList"
            :value="optionItem.id"
            :key="optionItem.id"
            :disabled="optionItem.disabled"
          >
            {{ optionItem.name }}
          </a-select-option>
        </a-select>
      </template>

      <!-- 业务类型 -->
      <template v-slot:business="slotProps">
        <a-select
          :placeholder="slotProps.item.placeholder || '请选择'"
          v-decorator="$decorator(slotProps.item.key, '请选择业务类型')"
          @focus="handleBgFocus"
          @change="changeBusiType"
        >
          <a-select-option
            v-for="optionItem in businessList"
            :value="optionItem.id"
            :key="optionItem.id"
            :disabled="optionItem.disabled"
          >
            {{ optionItem.name }}
          </a-select-option>
        </a-select>
      </template>
    </CardEdit>
  </div>
</template>
<script>
import { CardEdit } from 'lxfintech-fe'

import { SCORE_CARD_SCHEMA } from '@/utils/staticData.js'
import mixin from './mixin'
import {
  addCuntomer,
  getBusinessList,
  getListCManager,
  getRegionList,
  getCountry,
  getFreezeModelList,
  getFreezeBgList,
  getRating,
} from '../api'
import { getFieldsErrorList } from 'utils/util'
import { mapGetters } from 'vuex'
const REGION_TYPE = 2,
  MODEL_TYPE = 3

export default {
  components: {
    CardEdit,
  },
  mixins: [mixin],
  name: 'CreateForm',
  props: ['cManagerList'],
  data() {
    return {
      visible: false,
      confirmLoading: false,
      MODAL_WIDTH: 1000,
      SCORE_CARD_SCHEMA,
      formLayout: 'horizontal',
      checkboxList: [],
      filters: [],
      destroyOnClose: true,
      activeKey: [1, 2],
      oId: '', //basic ID
      basicOperating: true, // 企业基本信息是否可操作
      businessList: [], //业务类型
      regionOptionList: [], //大区optionList
      modelOptionList: [], //业务模式列表
      modelList: [], //冻结业务模式
      syList: [], //冻结业务类型
    }
  },
  computed: {
    // 信用主管默认选择当前用户
    ...mapGetters('user', ['username']),
  },
  mounted() {
    this._getCountry()
    this._getListCManager()
    this._getBusinessList()
    this._getFreezeBgList()
    //获取自定义评分卡
    getRating().then(({ data }) => {
      var list = []
      data.forEach(item => {
        list.push({ value: item.id, label: item.cardName })
      })
      this.SCORE_CARD_SCHEMA = this.SCORE_CARD_SCHEMA.concat(list)
      this.getScore()
    })
  },
  methods: {
    //业务模式禁用
    handleModelFocus() {
      if (this.modelOptionList) {
        this.modelOptionList.forEach(item => {
          item.disabled = false //每次下拉都需要重置禁用属性
        })
      }
      if (this.modelList) {
        this.modelOptionList.forEach(item => {
          this.modelList.forEach(myitem => {
            if (item.id === myitem.id) {
              item.disabled = true
            }
          })
        })
        this.$forceUpdate() //刷新组件
      }
    },

    //业务类型禁用
    handleBgFocus() {
      if (this.businessList) {
        this.businessList.forEach(item => {
          item.disabled = false //每次下拉都需要重置禁用属性
        })
      }
      if (this.syList) {
        this.businessList.forEach(item => {
          this.syList.forEach(myitem => {
            if (item.id === myitem.id) {
              item.disabled = true
            }
          })
        })
        this.$forceUpdate() //一定要刷新组件！！！！！！！！！！！！
      }
    },

    _getFreezeBgList() {
      getFreezeBgList().then(({ data }) => {
        this.syList = data
      })
    },

    // 获取国家
    async _getCountry() {
      const { data } = await getCountry()
      this.BASIC_INFO_SCHEMA.national.optionList = data.map(item => {
        return { label: item, value: item }
      })
    },
    //信用主管
    async _getListCManager() {
      try {
        const { data } = await getListCManager()
        this.BASIC_INFO_SCHEMA.businessSupervisor.optionList = this.BASIC_INFO_SCHEMA.creditManager.optionList = data.map(
          item => {
            return {
              label: item.name + '-' + item.username,
              value: item.username,
            }
          },
        )
        // // 信用主管默认选择当前用户
        // Object.keys(this.sourceDataBasic).forEach(key => {
        //   if (key == 'creditManager') {
        //     this.sourceDataBasic[key] = this.username
        //   }
        // })
      } catch (err) {
        console.log(err)
      }
    },
    //业务类型
    // async _getBusinessList() {
    //   try {
    //     const { data } = await getBusinessList()
    //     this.businessList = data
    //     this.BASIC_INFO_SCHEMA.business.optionList = data.map(item => {
    //       return { label: item.name, value: item.id }
    //     })
    //   } catch (err) {
    //     console.log(err)
    //   }
    // },
    async _getBusinessList() {
      try {
        const { data } = await getBusinessList()
        this.businessList = data
        // this.BASIC_INFO_SCHEMA.business.optionList = data.map(item => {
        //   return { label: item.name, value: item.id }
        // })
      } catch (err) {
        console.log(err)
      }
    },
    changeBusiType(value) {
      this.setCardEditFormFieldsValue()
      ;[REGION_TYPE, MODEL_TYPE].forEach(type => {
        this.fetchRegionList(value, type)
      })
    },
    //大区｜模式 联动
    handleBusiTypeChange(value) {
      this.setCardEditFormFieldsValue()
      ;[REGION_TYPE, MODEL_TYPE].forEach(type => {
        this.fetchRegionList(value, type)
      })
    },
    // 清空
    setCardEditFormFieldsValue() {
      const list = ['region', 'model']
      list.forEach(key => {
        this.$refs.formBasic.setFormFieldsValue(key, '')
      })
    },
    // 筛选
    async fetchRegionList(pid, type) {
      try {
        const { data } = await getRegionList({ pid, type })
        this.setOptionListByType(type, data)
      } catch (error) {
        console.error(error)
      }
    },
    setOptionListByType(type, data) {
      switch (type) {
        case REGION_TYPE:
          this.regionOptionList = data
          return
        case MODEL_TYPE:
          this.modelOptionList = data
          this._getFreezeModelList()
          return
      }
    },
    _getFreezeModelList() {
      getFreezeModelList().then(({ data }) => {
        this.modelList = data
      })
    },
    // 默认评分卡
    getScore() {
      this.BASIC_INFO_SCHEMA.defaultScoreType.optionList = this.SCORE_CARD_SCHEMA
    },
    // 新增企业
    add() {
      this.visible = true
    },
    // 取消 - modal
    handleCancel() {
      this.visible = false
    },
    // 校验 - 企业基本信息
    async validateForm() {
      try {
        var values = await this.$refs.formBasic.handleSubmit()
        const passed = !!values
        if (passed) {
          // 校验通过，返回数据
          this.clearFieldsError()
          values = {
            ...values,
            signDate: values.signDate.format('YYYY-MM-DD'),
            registerDate: values.registerDate.format('YYYY-MM-DD'),
          }
          for (let key in this.sourceDataBasic) {
            this.sourceDataBasic[key] = values[key]
          }
          return this.sourceDataBasic
        }
      } catch (err) {
        console.log(err)
      }
      // 校验未通过，获取未通过的项
      this._getFieldsErrorsList()
      return false
    },

    // 保存 - 企业基本信息
    async handleSubmitBasic() {
      try {
        var dataValid = await this.validateForm()
        if (dataValid) {
          const { data } = await addCuntomer(
            Object.assign({}, dataValid, { id: this.oId }),
          )
          this.oId = data
          this.$emit('setCode', this.sourceDataBasic.code)
          this.$notification.success({
            message: '提示',
            description: '成功',
          })
          this.$router.push({ name: 'client-center' })
        }
      } catch (err) {
        console.log(err)
      }
    },

    // 获取未通过校验的项
    _getFieldsErrorsList() {
      const $formBasic = this.$refs.formBasic
      const formBasicFieldsError = getFieldsErrorList(
        $formBasic.getFieldsError(),
        'formBasic',
      )
      this.$emit('setFieldErrors', formBasicFieldsError)
    },
    clearFieldsError() {
      this.$emit('setFieldErrors', [])
    },

    reset() {
      this.$refs.formBasic.handleReset()
    },
  },
}
</script>
<style scoped>
.margin-left-20 {
  margin-left: 20px;
}
.client-center-home
  >>> .ant-collapse
  > .ant-collapse-item
  > .ant-collapse-header {
  line-height: 30px;
}
</style>
